module.exports = __webpack_public_path__ + "img/logo-10.7639e79f.svg";